import { ArrowBack } from '@mui/icons-material';
import {
  Avatar,
  Box,
  Button,
  Card,
  LinearProgress,
  Rating,
  Typography,
  useTheme,
} from '@mui/material';
import { MediaPlayer, MediaProvider } from '@vidstack/react';
import {
  defaultLayoutIcons,
  DefaultVideoLayout,
} from '@vidstack/react/player/layouts/default';
import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';
import Editor from '@/components/tiptap/Editor';

export default function CourseOverview({ course }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '1200px',
        maxWidth: '90%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        justifySelf: 'center',
        gap: 2,
        py: 4,
        flexDirection: 'row',
        [theme.breakpoints.down('sm')]: {
          flexDirection: 'column',
        },
      }}
    >
      <Box
        sx={{
          width: '300px',
          gap: 2,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Card
          sx={{
            p: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5,
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <Avatar alt={course.title} src={course.instructorImage} />
            <Box
              sx={{
                ml: 2,
                justifyContent: 'center',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <Typography
                variant="body1"
                sx={{ fontWeight: 'bold', lineHeight: 1.2 }}
              >
                {course.instructor}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ lineHeight: 1.2 }}
              >
                {course.instructorCompany}
              </Typography>
            </Box>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
            {course.aboutInstructor}
          </Typography>
          <Rating value={course.rating} readOnly precision={0.5} />
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
              Gewichtung
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {course.totalLessons} XP
            </Typography>
          </Box>
          <LinearProgress variant="determinate" value={100} />
        </Card>
        <Button fullWidth startIcon={<ArrowBack />} to="/learning">
          Zurück zur Kursübersicht
        </Button>
      </Box>
      <Card sx={{ flex: 1, minWidth: 0 }}>
        {course.video && (
          <MediaPlayer
            title="Sprite Fight"
            src={course.video}
            style={{ borderRadius: 0 }}
          >
            <MediaProvider />
            <DefaultVideoLayout
              thumbnails="https://files.vidstack.io/sprite-fight/thumbnails.vtt"
              icons={defaultLayoutIcons}
            />
          </MediaPlayer>
        )}
        {course.image && !course.video && (
          <Box
            component="img"
            src={course.image}
            alt={course.title}
            sx={{ width: '100%', height: 'auto' }}
          />
        )}
        <Box sx={{ px: 3, pb: 2 }}>
          <Editor content={course.readme} editable={false} />
        </Box>
      </Card>
    </Box>
  );
}
